import { Component, OnInit, OnChanges, Input, Output, ViewChild, EventEmitter } from '@angular/core';
// models
import { BookingInitState } from '../../../models/booking-reducer.interface';
import { UserInitState } from '../../../../shared/models/user-reducer.interface';
import { COUNTRY_CODES } from '../../../../shared/globals'

declare var ga: any;

@Component({
  selector: 'app-recurring-payment',
  templateUrl: './recurring-payment.component.html',
  styleUrls: ['./recurring-payment.component.scss']
})
export class RecurringPaymentComponent implements OnInit, OnChanges {

  @Output() handlePaymentType = new EventEmitter<any>();

  @Input() paymenttype;
  @Input() bookingState: BookingInitState;
  @Input() user: UserInitState;
  @Input() price;
  @Input() oldprice;
  @Input() appCopy;
  @Input() payByInvoice;
  @Input() overridePayment: boolean;
  @Input() flightDirection;
  @Input() billingAddress;
  @Input() billingAddressValid;
  @Input() isCustomerSupport;
  @Input() selectedLanguage;
  @Input() formData;
  @Input() PaymentTypeAvailable;

  @Output() deleteSavedCard: EventEmitter<any> = new EventEmitter();

  @ViewChild('form') form;
  @ViewChild('billingAddressForm') billingAddressForm;

  public bookingType;
  public countryCodes = COUNTRY_CODES.all;
  public subscribeNewsletter = false;
  public userCards;
  public userHasCards = false;
  public selectedCardItem;
  public selectedCardDetails;
  public initialCardDetails;
  public bookingProduct;
  public hasBillingAddress = true;
  public billingAddressSame = true;
  public cardNumberPattern = /^[0-9\s]{12,23}$/;
  public expiryMonthPattern = /^(0?[1-9]|1[0-2])$/;
  public expiryYearPattern = /^(\d{2})$/;
  public cardSecurityPattern = /^[0-9]*$/;
  public formValues: any = {
    ccnumber: '',
    nameoncard: '',
    ccexpmonth: '',
    ccexpyear: '',
    CardSecurityCode: '',
    billingAddress: '',
    selectedCardItem: ''
  };

  constructor() { }

  ngOnInit() {
    this.bookingProduct = this.bookingState.bookingDetails.bookingProduct;
    this.setUserValues();
    console.log(this.paymenttype);

    if (this.formData.set && this.formData.data && this.formData.data.recurringForm) {
      this.formValues.ccnumber = this.formData.data.recurringForm.ccnumber;
      this.formValues.nameoncard = this.formData.data.recurringForm.nameoncard;
      this.formValues.ccexpmonth = this.formData.data.recurringForm.ccexpmonth;
      this.formValues.ccexpyear = this.formData.data.recurringForm.ccexpyear;
      this.formValues.CardSecurityCode = this.formData.data.recurringForm.CardSecurityCode;
      this.formValues.billingFormData = this.formData.data.recurringForm.billingFormData;
      this.formValues.selectedCardItem = this.formData.data.recurringForm.selectedCardItem;

      this.hasBillingAddress = !this.formData.data.recurringForm.billingForm;
      if (this.formValues.selectedCardItem) {
        this.setSelectedCard(this.formValues.selectedCardItem);
      } else {
        this.selectedCardItem = 'newCard';
      }
    }

  }

  // on user changes
  // set user values
  ngOnChanges(changes: any) {
    if (changes.user) {
      if (!changes.user.firstChange) {
        this.user = changes.user.currentValue;
        this.setUserValues();
      }
    }

    if (changes.billingAddress) {
      this.billingAddress = changes.billingAddress.currentValue;
    }

    if (changes.billingAddressValid) {
      this.billingAddressValid = changes.billingAddressValid.currentValue;
    }
  }

  useSaveCard() {
    this.selectedCardItem = this.initialCardDetails.recurringDetailReference;
    ga('send', 'event', 'Vanilla', 'Pay - Card', 'Use-Saved');
  }

  clickSaveCard(val: any) {
    if (val.currentTarget.checked === true) {
      ga('send', 'event', 'Vanilla', 'Pay - Card', 'Save');
    }
  }

  setSelectedCard(ref) {
    if (this.bookingState.bookingDetails.bookingType === 'amend') {
      this.selectedCardDetails = this.user.userDetails.currentUser.cardDetails[0];
    } else {
      this.selectedCardDetails = this.user.userDetails.currentUser.cardDetails.find(card => card.recurringDetailReference === ref);
    }

    this.selectedCardItem = this.selectedCardDetails.recurringDetailReference;
    this.hasBillingAddress = this.selectedCardDetails.billingAddress !== null;

    if (this.hasBillingAddress) {
      this.formatBillingAddress(this.selectedCardDetails.billingAddress);
    }
  }

  setUserValues() {
    this.bookingType = this.bookingState.bookingDetails.bookingType;

    if (this.bookingState.bookingDetails.bookingType !== 'amend') {
      // if not amend - get cards from currentUser obj
      if (this.user.userDetails.currentUser['cardDetails'] === null || typeof this.user.userDetails.currentUser['cardDetails'] === 'undefined') {
        this.userHasCards = false;
      } else {
        this.userHasCards = true;
        this.userCards = this.user.userDetails.currentUser.cardDetails;
        this.selectedCardItem = this.user.userDetails.currentUser.cardDetails[0].recurringDetailReference;
        this.selectedCardDetails = this.user.userDetails.currentUser.cardDetails[0];
        this.initialCardDetails = this.selectedCardDetails;
        this.hasBillingAddress = this.selectedCardDetails.billingAddress !== null;
      }
    } else if (this.bookingState.bookingDetails.bookingType === 'amend') {
      // if amend - check user cards sent in getCompleteBookingRequest (amendUserCards)
      // saved in user reducer
      if (this.user.userDetails.amendUserCards === null || typeof this.user.userDetails.amendUserCards === 'undefined') {
        this.userHasCards = false;
      } else {
        this.userHasCards = true;
        this.userCards = this.user.userDetails.amendUserCards;
        this.selectedCardItem = this.user.userDetails.amendUserCards[0].recurringDetailReference;
        this.selectedCardDetails = this.user.userDetails.amendUserCards[0];
        this.initialCardDetails = this.selectedCardDetails;
      }
    }

    if (this.selectedCardDetails && this.selectedCardDetails.billingAddress) {
      this.formatBillingAddress(this.selectedCardDetails.billingAddress);
      this.billingAddressSame = false;
    } else {
      this.hasBillingAddress = this.billingAddress !== null;
      this.billingAddressSame = this.billingAddress !== null;
    }

  }

  formatBillingAddress(address) {
    this.billingAddress = {
      country: address.countryCodeName,
      city: address.addressTown,
      street: address.addressLine2,
      houseNumberOrName: address.addressLine1,
      stateOrProvince: address.addressCounty,
      postalCode: address.addressPostCode
    };
    this.billingAddressValid = true;
  }

  toggleBillingAddress() {
    this.hasBillingAddress = !this.hasBillingAddress;
  }

  // A saved payment method can be a PayPal token rather than a card: Adyen
  // returns it in the same cardDetails array, with a null expiry and an email
  // address in the number field instead of a card number.
  isPaypalCard(card): boolean {
    return !!card && (card.cardType || '').toLowerCase() === 'paypal';
  }

  setCardLogo(value) {

    const logoClass = 'sprite-common--cards-';
    let type;

    if (value === null || typeof value === 'undefined') {
      type = '';
    } else {
      type = value.toLocaleLowerCase();
    }

    switch (type) {

      case 'visa':
        return logoClass + 'visa';

      case 'mastercard':
        return logoClass + 'mastercard';

      case 'maestro':
        return logoClass + 'maestro';

      case 'amex':
        return logoClass + 'amex';

      // PayPal has no sprite - the template renders images/PayPal.svg instead.
      case 'paypal':
        return null;

      default:
        return logoClass + 'default';
    }

  }

  deleteCard(ref) {
    this.deleteSavedCard.emit(ref);
    ga('send', 'event', 'Vanilla', 'Pay - Card', 'Remove');
  }

  sendPaymentType(value: number) {
    this.handlePaymentType.emit(value);
  }

}
